/* eslint-disable max-len */
PHI.product = {
  /* eslint-disable vars-on-top */
  bindToAddToCartForm: function() {
    var $addToCartForm = $('.add_to_cart_form'),
        txtToCartBtn = 'ToCartButton',
        addToCartButton = '.ph-add' + txtToCartBtn,
        disableCart = 'ph-cart-disable';

    if ($addToCartForm.length > 0) {
      $addToCartForm.ajaxForm({
        beforeSubmit: this.disableAddToCartButton,
        success: this.displayAddToCartPopup,
        error: function() {
          $.colorbox.close();
          setTimeout(function() {
            $(addToCartButton).attr('disabled', false);
            $('.ph-cart').removeClass(disableCart);
          }, 200);
        }
      });
    }
  },

  showAddToCart: function() {
    ACC.minicart.hideMiniCart();
    $('#addToCartLayer').fadeIn(function() {
      if ($.colorbox) {
        $.colorbox.close();
      }

      var timeoutId = setTimeout(function() {
        $('#addToCartLayer').fadeOut(function() {
          $('#addToCartLayer').remove();
          $('.hide_add_to_cart').hide();
        });
      }, 8000);

      if (typeof timeoutId !== 'undefined') {
        clearTimeout(timeoutId);
      }

      $('.loader').hide();
      $('.wait-message').hide();
    });
  },

  displayAddToCartPopup: function(cartResult, statusText, xhr, formElement) { /* eslint-disable xss/no-mixed-html */
    ACC.common.$globalMessages.html(cartResult.cartGlobalMessagesHtml);

    $('#addToCartLayer').remove();
    $('.hide_add_to_cart').hide();

    if (cartResult.miniCartCount) {
      /* We refresh the minicart with the cartResults (instead of doing a second call in ACC.minicart.refreshMiniCartCount
         Moreover we are not interested in loading the price in the minicart */
      $('#miniCartIcon').html('<div class="quantity-balloon"></div>');
      $('#miniCartIcon .quantity-balloon').html(cartResult.miniCartCount);
      ACC.minicart.$layer.data('needRefresh', true);
    }

    $('#header').append(cartResult.addToCartLayer);

    ACC.product.showAddToCart();

    ACC.product.enableAddToCartButton(formElement);
  },


  /* Fixed: the accelerator matches elements by ID, which doesn't work
     For a page with multiple addToCartButtons (PLP) */
  enableAddToCartButton: function(form) {
    $('.ph-addToCartButton').attr('disabled', false);
    $('.ph-cart').removeClass('ph-cart-disable');
    $('.ph-outofstockdisablebtn').parent().attr('disabled', 'disabled');

    if (form) {
      $('.addToCartButton').each(function() {
        $(this).removeClass('ph-disable-button');
      });
    } else {
      $('.add_to_cart_form').children(':button').removeProp('disabled');
    }
  },

  /* Improvement: Disable buttons whenever they are being added to the cart
     In order to avoid plural clicks */
  disableAddToCartButton: function() {
    $('.addToCartButton').each(function() {
      $(this).addClass('ph-disable-button');
    });
  }

};

$.extend(true, ACC.product, PHI.product);

$(document).on('click', '.ph-pdppagepopup', function() {
  window.sto = setTimeout(function() {
    var popWidth = '',
        popFlagVar = $('.ph-recom-flag').attr('data-popup-flag'),
        buttonChk = 'btnMob',
        continueSec = '.ph-interstitial-margin-checkout',
        localcarttoggle = $('#ph-localcarttoggle').val();

    if (popFlagVar === 'true') {
      popWidth = '795px';
    } else {
      popWidth = '460px';
    }

    if ($(window).width() > 600) {
      $(continueSec + '-' + buttonChk).addClass('hidden');
    } else {
      $(continueSec + '-btn').addClass('hidden');
      $(continueSec + '-' + buttonChk).removeClass('hidden');
    }

    $('.ph-interstitial-top-section').css('pointer-events', 'none');
    $('.ph-interstitial-close-btn').css('pointer-events', 'none');


    if ((popFlagVar === 'true' && localcarttoggle === 'true') || (popFlagVar === 'true' && localcarttoggle === 'false') || (popFlagVar === 'false' && localcarttoggle === 'false')) {
      $.colorbox({
        width: popWidth,
        maxWidth: '91%',
        html: $('.ph-interstitisal').html(),
        overlayClose: false,
        closeButton: false,
        onClosed: function() {
          if (popFlagVar === 'true') {
          // Added for loader
            $('.ph-recommended-productsPDP').addClass('hidden');
            $('.ph-interstitial-margin-checkout-' + buttonChk).addClass('hidden');
            $('#cboxLoadedContent .ph-seemore_link').hide();
            $('.ph-recommended-products-desk').addClass('hidden');
            $('.ph-spinnerinterstitial').removeClass('hidden');
            $('.ph-interstitial-addingtocart-btn').removeClass('hidden');
            $('.ph-interstitial-popup-warning').addClass('hidden');
            $('.ph-interstitial-popup-error').addClass('hidden');
            $('.ph-interstitial-popup-success').addClass('hidden');
            ACC.common.refreshScreenReaderBuffer();
          } else {
            ACC.common.refreshScreenReaderBuffer();
          }
        }
      });
    }

    return true;
  }, 300);
});

$(document).on('click', '.ph-pdpPopData', function() {
  var elementId = '.ph-pdp_description_rightsection';

  ACC.decisionPageInfiniteLoader.loadPopPdpProductData(elementId);

  window.sto = setTimeout(function() {
    var popWidth = '',
        btnNext = 'btnMob',
        checkoutSec = 'ph-interstitial-margin-checkout-',
        stringEvents = 'events',
        popFlagVarhere = $('.ph-recom-flag').attr('data-popup-flag'),
        localcarttoggle = $('#ph-localcarttoggle').val();

    if (popFlagVarhere === 'true') {
      popWidth = '795px';
    } else {
      popWidth = '460px';
    }

    if ($(window).width() > 600) {
      $('.' + checkoutSec + btnNext).addClass('hidden');
    } else {
      $('.ph-interstitial-margin-checkout-btn').addClass('hidden');
      $('.ph-interstitial-margin-checkout-' + btnNext).removeClass('hidden');
    }

    $('.ph-interstitial-top-section').css('pointer-' + stringEvents, 'none');
    $('.ph-interstitial-close-btn').css('pointer-' + stringEvents, 'none');

    if ((popFlagVarhere === 'true' && localcarttoggle === 'true') || (popFlagVarhere === 'true' && localcarttoggle === 'false') || (popFlagVarhere === 'false' && localcarttoggle === 'false')) {
      $.colorbox({
        width: popWidth,
        maxWidth: '90%',
        html: $('.ph-interstitisal').html(),
        overlayClose: false,
        closeButton: false,
        onClosed: function() {
          if (popFlagVarhere === 'true') {
          // Added for loader
            $('.ph-recommended-productsPDP').addClass('hidden');
            $('.' + checkoutSec + btnNext).addClass('hidden');
            $('#cboxLoadedContent .ph-seemore_link').hide();
            $('.ph-recommended-products-desk').addClass('hidden');
            $('.ph-spinnerinterstitial').removeClass('hidden');
            $('.ph-interstitial-addingtocart-btn').removeClass('hidden');
            $('.ph-interstitial-popup-warning').addClass('hidden');
            $('.ph-interstitial-popup-error').addClass('hidden');
            $('.ph-interstitial-popup-success').addClass('hidden');
            ACC.common.refreshScreenReaderBuffer();
          } else {
            ACC.common.refreshScreenReaderBuffer();
          }
        }
      });
    }

    return true;
  }, 300);

  /* eslint-enable xss/no-mixed-html */
  /* eslint-enable vars-on-top */
});

/* eslint-enable max-len */
